import axios from 'axios'

const api = `/api/grids/areaSonList`

const areaMapCacheHandle = () => {
    window.addEventListener('load', () => { // 需要重置缓存时
        if (window.localStorage.getItem('clearAreaCache')) {
            window.localStorage.removeItem('JLINKADDRESS_LOCAL_CACHE')
            window.localStorage.removeItem('clearAreaCache')
        } else {
            state.areaIdChildMap = JSON.parse(window.localStorage.getItem('JLINKADDRESS_LOCAL_CACHE') || '{}')
            if (state.areaIdChildMap['0'] && state.areaIdChildMap['0'].length === 34) { // 全国数据正常情况
                areaIdNameMapCacheHandle(state.areaIdChildMap) // 正常解析缓存
            } else { // 全国数据异常 清空缓存
                state.areaIdChildMap = {}
                window.localStorage.removeItem('JLINKADDRESS_LOCAL_CACHE')
                window.localStorage.removeItem('clearAreaCache')
            }
        }
    })
    window.addEventListener('beforeunload', () => {
        if (window.localStorage.getItem('clearAreaCache')) {
            window.localStorage.removeItem('JLINKADDRESS_LOCAL_CACHE')
            window.localStorage.removeItem('clearAreaCache')
            return
        }
        if (state.areaIdChildMap['0'] && state.areaIdChildMap['0'].length === 34) {
            window.localStorage.setItem('JLINKADDRESS_LOCAL_CACHE', JSON.stringify(state.areaIdChildMap))
        } else {
            window.localStorage.removeItem('JLINKADDRESS_LOCAL_CACHE')
            window.localStorage.removeItem('clearAreaCache')
        }
    })
}

const areaIdNameMapCacheHandle = (map) => {
    const array = []
    for (let key in map) { array.push(...map[key]) }
    array.forEach(item => state.areaIdNameMap[item.areaId] = item.name)
    console.log('本地缓存解析完了')
}

// 本地缓存 (可通过控制台输入命令手动清空缓存、缓存数据校验异常时自动清空缓存)
areaMapCacheHandle()

const state = {
    areaIdNameMap: {},
    areaIdChildMap: {}
}

const mutations = {
    areaIdNameMap (state, payload) {
        state.areaIdNameMap = Object.assign(state.areaIdNameMap, payload)
    },
    areaIdChildMap (state, payload) {
        if (payload.remove) {
            delete state.areaIdChildMap[payload.areaId]
        } else {
            if (!state.areaIdChildMap[payload.areaId]) state.areaIdChildMap[payload.areaId] = payload.children
            else state.areaIdChildMap[payload.areaId].push(...payload.children)
        }
    }
}

const actions = {
    async getAddressById (content, areaId) {
        let children = []
        if (content.state.areaIdChildMap[areaId || '0']) {
            // console.log('areaId:',areaId || '0','返回缓存了')
            return content.state.areaIdChildMap[areaId || '0']
        }
        content.commit('areaIdChildMap', { areaId: areaId || '0', children })
        const { data } = await axios.get(api, { params: { areaId } }).catch(error => { console.error(`${api}接口，城市信息获取异常`,error.response) })
        if (data.status != 'yes') return console.error(`${api}接口，城市信息获取异常`)
        if (data.data.length === 0) { // 异常数据移除
            content.commit('areaIdChildMap', { areaId: areaId || '0', children, remove: true })
            return []
        }
        children = data.data
        let map = {}
        children.forEach(area => map[area.areaId] = area.name)
        content.commit('areaIdNameMap', map)
        content.commit('areaIdChildMap', { areaId: areaId || '0', children })
        // console.log(JSON.stringify(content.state.areaIdChildMap[0]))
        // console.log('areaId:',areaId || '0','请求接口了')
        return content.state.areaIdChildMap[areaId || '0']
    }
}

// 模块方式注册
export const JLinkAddress = {
    namespaced: true,
    state,
    mutations,
    actions
}
